// jscs:disable
import 'jquery';


// WEBPACK FOOTER //
// ./src/js/index.jquery.js